import React from 'react';
import styles from './Error.scss';

// deprecated!!! ErrorMessageコンポーネントの使用を推奨します
export const Error = ({ error, label = '' }) => {
  return (
    <>
      {error && (
        <p className={styles.error}>
          <span>{`${label}${error}`}</span>
        </p>
      )}
    </>
  );
};
